import { EntityRoutes } from 'routes/constants';
import { DateFormats } from 'UI/constants/defaults';

export const TASK_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'roleId',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'taskStatus',
    label: 'Action Status',
    options: {
      filter: true,
      display: true,
      renderer: 'taskStatus'
    }
  },
  {
    name: 'taskType',
    label: 'Action Type',
    options: {
      filter: true,
      display: true,
      setCellHeaderProps: () => ({
        style: { minWidth: 150 }
      })
    }
  },
  {
    name: 'startDate',
    label: 'Date & Time',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'contact',
    label: 'Reach Out to',
    options: {
      sort: true,
      display: true,
      renderer: 'contactLink'
    }
  },
  {
    name: 'entity',
    label: 'Contact Type',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'contactStatus',
    label: 'Contact Status',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'candidateType',
    label: 'Candidate Type',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'companyType',
    label: 'Company Type',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'title',
    label: 'Title',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'company',
    label: 'Company',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          idKey: 'id',
          textKey: 'name',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'callType',
    label: 'Call Type',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'outcome',
    label: 'Outcome',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'lastComment',
    label: 'Latest Comment',
    options: {
      sort: true,
      display: true,
      setCellHeaderProps: () => ({
        style: { minWidth: 400 }
      })
    }
  },
  {
    name: 'createdAt',
    label: 'Created on',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'dateBuilder',
        config: { format: DateFormats.MonthDayYearTime }
      }
    }
  },
  {
    name: 'updatedAt',
    label: 'Last Updated on',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'dateBuilder',
        config: { format: DateFormats.MonthDayYearTime }
      }
    }
  },
  {
    name: 'lastCommentAt',
    label: 'Last Comment on',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'dateBuilder',
        config: { format: DateFormats.MonthDayYearTime }
      }
    }
  },
  {
    name: 'createdByName',
    label: 'Created by',
    options: {
      sort: true,
      display: true
    }
  }
];
